export default __webpack_public_path__ + "static/media/first-place.dc9b898c.svg";